<template>
  <div class="cases-center">
    <div class="content">
      <!-- <h2>成功案例</h2> -->
		<!-- <div :style="{'position' isFixed ? 'fixed':'relative'}"> -->
		<!-- <div :style=" isFixed ? 'position:fixed':'position:relative'"> -->
		<div style="position:relative">
      <ul class="case-type">
        <li :class="{ selected: -1 == actIndex }" @click="caseType()">全部</li>
        <li
          v-for="item in type"
          :key="item.id"
          :class="{ selected: item.id == actIndex }"
          @touchstart="caseType(item.name, item.id)"
        >
          {{ item.name }}
        </li>
      </ul>
      <div
        class="case-label"
        @touchmove.prevent
      >
		<div style="position: relative;">
			
		
        <ul class="head-list">
          <li
            :class="{ selected: selectLabel.length == 0 }"
            @click="caseType()"
          >
            全部
          </li>
          <li
            v-for="(item, index) in labelList"
            :key="item.id"
            :class="{ selected: selectLabel.indexOf(item.id) != -1 }"
            @touchstart="caseLabel(item.id, 1)"
            v-if="index <= 2"
          >
            {{ item.title }}
          </li>

          <li @click="openMore">更多</li>
        </ul>
        <!-- <span :class="{selected: -1 == actIndex}" @click="caseType()">更多</span> -->
		  <div style="position: absolute;top:3em;background: #fff; padding-bottom:10rpx ;z-index: 999;">
		  	
		 
        <ul class="label-cont" v-if="isMore">
          <li
            v-for="item in labelList"
            :key="item.id"
            :class="{ selected: selectLabel.indexOf(item.id) != -1 }"
            @touchstart="caseLabel(item.id)"
          >
            {{ item.title }}
          </li>
        </ul>
        <div class="label-btn" v-if="isMore" @click="labelBtn">确定</div>
		   </div>
		  </div>
      </div>
		</div>
      <div class="cases-show">
        <ul>
          <li
            v-for="(item, index) in caseData"
            :key="item.id"
            @click="caseDetail(item, index)"
          >
            <img :src="item.cover_image" alt="" />
            <h3>{{ item.title }}</h3>
            <p><span>服务品牌</span> {{ item.service_brand }}</p>
            <h5>
              <span
                v-for="(itemLab, indexLab) in item.industry_label_ids"
                :key="indexLab"
                >{{ itemLab }}</span
              >
            </h5>
            <!-- <transition>
                            <div v-show="index == actCase && item.code != ''" class="code-show">
                                <img :src="$imgUrl + item.code" alt="">
                            </div>
                        </transition> -->
          </li>
        </ul>
      </div>
      <!-- <div class="swiper-tool">
                <i class="cases-swiper-button-prev"><</i><i class="cases-swiper-button-next">></i>
                <div class="cases-swiper-pagination"></div>
            </div> -->

      <div class="item" style="justify-content: center">
        <div class="clip-page">
          <button @click="upPage">上一页</button>
          <button class="clip">{{ page }}/{{ total }}</button>
          <button @click="downPage">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CasesCenter",
  props: {
    cases: Array,
    type: Array,
  },
  mounted() {
    // console.log(this.caseData)
  },
  data() {
    return {
      actIndex: -1,
      actCase: -1,
      caseData: [], //数据列表
      caseArr: {},
      isMore: false, //打开展示更多
      selectLabel: [], //选中的label的列表
      labelList: [], //行业标签
      caseList: [], //数据储存列表
      page: 1,
      total: "",
      emdList: {},
		isFixed:false
    };
  },
  watch: {
    // cases (newVal) {
    //     this.caseData = newVal
    //     this.caseTypeArr ()
    // }
  },
  mounted() {
	   window.addEventListener('scroll', this.getScroll);
    this.getLabelList();
    this.getCaseList();
    this.getemd();
  },
  methods: {
	   getScroll(){
	   
	              let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

					  // console.log("111",scrollTop)
	                if (scrollTop >= 300){            
									this.isFixed = true
							}else{
								this.isFixed = false
							}
	          },
    upPage() {
      //上一页
      if (this.page > 1) {
        this.page--;
        this.getCaseList();
      }
    },
    downPage() {
      //下一页
      if (this.page < this.total) {
        this.page++;
        this.getCaseList();
      }
    },
    labelBtn() {
      this.page = 1;
      this.getCaseList();
      this.isMore = false;
    },
    getLabelList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/vocationtag",
        {},
        (res) => {
          if (res.code == 1) {
            this.labelList = res.data;
            this.labelList.reverse();
          }
        }
      );
    },
    getemd() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com//api/index/case_list",
        {},
        (res) => {
          // console.log(res.data);
          if (res.code == 1) {
            this.emdList = res.data;
          }
        }
      );
    },
    getCaseList() {
      let params = {
        industry_id: this.actIndex == -1 ? 0 : this.actIndex,
        label_id:
          this.selectLabel.length == 0 ? 0 : this.selectLabel.toString(),
        // label_id:[3,4,5],
        page: this.page,
      };
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/case_list",
        params,
        (res) => {
          if (res.code == 1) {
            this.total = res.data.last_page;
            this.caseData = res.data.data;
          }
        }
      );
    },
    openMore() {
      this.isMore = !this.isMore;
      window.scrollTo(0, 0);
    },
    caseLabel(id, num) {
      let selectLabe = this.selectLabel;
      let index = selectLabe.indexOf(id);
      if (index == -1) {
        if (selectLabe.length <= 3) {
          selectLabe.push(id);
        }
      } else {
        selectLabe.splice(index, 1);
      }
      this.selectLabel = selectLabe;
      if (num == 1) {
        this.labelBtn();
      }
    },
    caseType(type, index) {
      if (type == null) {
        this.caseData = this.caseArr.all;
        this.actIndex = -1;
      } else {
        this.caseData = this.caseArr[type];
        this.actIndex = index;
      }
      // console.log(this.caseDate)
    },
    caseTypeArr() {
      for (var i = 0; i < this.cases.length; i++) {
        var type = this.cases[i].cate;
        if (!this.caseArr[type]) {
          this.caseArr[type] = [];
        }
        this.caseArr[type].push(this.cases[i]);
      }
      this.caseArr.all = this.cases;
      // console.log(this.caseArr)
    },
    caseDetail(item, index) {
      // event.preventDefault()
      if (item.link) {
        window.location.href = item.link;
        return;
      } else if (!item.code) {
        this.$router.push("/m_casedetail/" + item.id);
        return;
      }
      this.actCase = index;
    },
  },
  computed: {},
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';
@import '~styles/mixins.styl';

.cases-center {
  background: #f6f6f6;

  .content {
    padding: 0.31rem 0 20%;
    text-align: center;

    h2 {
      color: #333;
      font-size: 0.4rem;
      font-weight: 1000;
      margin-bottom: 0.4rem;
      letter-spacing: 1px;
    }

    .case-label {
      width: 100%;
      background: #FFFFFF;
      border-top: 1px solid rgba(225, 230, 240, 1);

      .head-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 3em;
			
        li {
          padding: 0.06rem 0;
          margin: 0 0.3rem;
          margin-bottom: 1.5%;
          // background: #ddd;
          color: #333;
          font-size: 0.26rem;
          border-radius: 0.04rem;
          position: relative;
        }

        li:last-child {
          padding: 0 0.2rem;
          border-left: 1px solid #E1E6F0;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }

      li.selected {
        background: rgba(255, 192, 0, 0.1);
        border-radius: 0rem;
        font-size: 0.26rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFC000;
      }

      span {
        padding: 0 0.2rem;
        border-left: 1px solid #E1E6F0;
        font-size: 0.26rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
      }
    }

    .more-label {
      position: fixed;
      // top: 7.59rem;
      z-index: 100;
      // overflow: hidden;
  //     height: auto;
		// overflow-y: scroll;
      // height: calc(100vh - 1.6%);
    }

    .label-btn {
      width: 4.8rem;
      height: 0.88rem;
      background: #FFC000;
      border-radius: 5%;
      line-height: 0.88rem;
      margin: 0 auto;
		margin-bottom 0.4rem;
    }

    .label-cont {
      display: flex;
      width: 100%;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 0 0.06rem 0.34rem 0.24rem;
      background: #FFFFFF;
      overflow: hidden;
      overflow-y: scroll;
		
      li {
        width: 22%;
        background: #F1F5F7;
        border-radius: 1px;
        margin: 0.1rem 0.18rem 0.1rem 0;
        height: 0.68rem;
        line-height: 0.68rem;
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        border-radius: 10%;
      }

      li.selected {
        background: #FFC000;
        color: #333333;
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        border-radius: 10%;
      }
    }

    .case-type {
      overflow: hidden;
      white-space: nowrap;
      overflow-x: scroll;
      // margin-bottom: 4%;
      display: flex;
      justify-content: flex-start;
      background: #FFFFFF;

      li {
        // float: left;
        padding: 0 0.11rem;
        margin: 0 0.3rem;
        margin-bottom: 1.5%;
        // background: #ddd;
        color: #333;
        font-size: 0.26rem;
        line-height: 2.8em;
        border-radius: 0.04rem;
        position: relative;
      }

      li:nth-of-type(5n) {
        margin-right: 0;
      }

      // li.selected {
      // color: #fff;
      // }
      li.selected::after {
        position: absolute;
        content: '';
        top: 2.1em;
        left: 50%;
        transform: translateX(-50%);
        width: 0.28rem;
        height: 0.06rem;
        background: red; // #FFC000;
        border-radius: 1rem;
      }
    }

    .cases-show {
      // width: 100%;
      padding: 0.3rem 4%;
      overflow: hidden;

      li {
        position: relative;
        width: 49%;
        float: left;
        margin: 0 2% 2% 0;
        background: #fff;
        text-align: left;

        >h3 {
          font-size: 0.28rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #03091B;
          padding: 0.1rem 0.2rem;
        }

        >p {
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
          padding: 0 0.2rem;

          >span {
            margin-right: 5px;
          }
        }

        >h5 {
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
          padding: 0.1rem;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          >span {
            margin: 0.1rem 0.1rem;
            background: #fff;
            padding: 0.04rem 0.09rem;
            background: rgba(245, 245, 245, 1);
          }
        }

        >img {
          width: 100%;
          vertical-align: middle;
        }

        .code-show {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.8);

          >img {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: 50%;
          }
        }
      }

      li:nth-of-type(2n) {
        margin-right: 0;
      }
    }

    .swiper-tool {
      display: inline-block;
      margin: 2em auto;
      font-size: 14px;
      background: #000;
      line-height: 3.4em;

      i {
        color: #fff;
        padding: 0 2em;
      }
    }
  }
}

.clip-page {
  display: flex;
  justify-content: center;

  button {
    margin: 0 5px;
    width: 60px;
    line-height: 26px;
    height: 26px;
    background: #eeeeee;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 14px;
    border: none;
    padding: 0;
    white-space: nowrap;

    &:hover {
      background: #e8e8e8;
    }
  }

  .clip {
    width: 60px;
    height: 26px;
    background: #f7d74c;
    border-radius: 4px;

    &:hover {
      background: #f0d020;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/CasesCenter.vue